<template>
	<div>
		<footer>
			<div class="footer w-1700">
				<el-image :src="`https://oss.paiqingnian.cn/a/2024002.png`"
					style="width: 344px; height: 62px" />
				<div>
					<p>
						湃青年 | 心湃智能是全球化视角下的人工智能产业协同平台，覆盖行业100+，学员30000+。专注AI商业应用落地场景，帮助企业实现100+应用落地场景。企业客户涵盖安踏、特步、可口可乐、百威等国内外知名企业，助力个体与企业提高新质生产力。
					</p>
					<p>© 2020-{{ currentYear }} 湃青年(厦门)教育科技有限公司 版权所有<br>
						<span class="beian-line">
							<img class="beian-icon" :src="require('@/assets/img/about/registration.png')" alt="" />
							<a class="beian-link" href="https://beian.mps.gov.cn/#/query/websearch?code=35020602003658" rel="noreferrer" target="_blank">闽公网安备35020602003658号</a>
							<a class="beian-icp" href="https://beian.miit.gov.cn/" rel="noreferrer" target="_blank">闽ICP备2024073688号</a>
						</span><br>
						注意：本站仅收录网站，不对其网站内容或交易负责。若收录的站点侵害到您的利益，请联系我们删除收录。 邮箱：
						service@paiqingnian.cn</p>
				</div>
				<div class="mode-item flex flex-align-center">
					<div class="item flex flex-align-center flex-justify-center">
						<span class="flex flex-justify-center">添加企微</span>
						<el-image :src="`https://oss.paiqingnian.cn/a/service.jpg`"
							style="width: 117.33px; height: 117.33px; border-radius: 13.33px;" />
					</div>
					<div class="item flex flex-align-center flex-justify-center">
						<span class="flex flex-justify-center">微信小程序</span>
						<el-image :src="`https://oss.paiqingnian.cn/a/2024.png`"
							style="width: 117.33px; height: 117.33px; border-radius: 13.33px;" />
					</div>
					<div class="item flex flex-align-center flex-justify-center">
						<span class="flex flex-justify-center">关注公众号</span>
						<el-image :src="`https://oss.paiqingnian.cn/a/gzh.jpg`"
							style="width: 117.33px; height: 117.33px; border-radius: 13.33px;" />
					</div>
				</div>
			</div>
		</footer>
	</div>
</template>
<script>
	export default {
		name: "footerIndex",
		data() {
			return {
				currentYear: new Date().getFullYear()
			}
		},
		methods: {},
		mounted() {}
	}
</script>

<style lang="less" scoped>
	footer {
		padding: 47.33px 0 52px;
		background: #202833;

		.footer {
			position: relative;

			.mode-item {
				position: absolute;
				top: 0;
				right: 10px;

				.item {
					margin: 0 0 0 78px;
					flex-direction: column;

					&:first-child {
						margin: 0;
					}
				}

				span {
					font-family: "HarmonyOS_Sans_SC ", serif;
					font-size: 21.33px;
					color: rgba(255, 255, 255, .5);
					margin-bottom: 13.33px;
				}
			}

			p {
				font-size: 18.67px;
				color: rgba(255, 255, 255, .5);
				margin: 33px 0 0;

				&:first-child {
					width: 676px;
				}
			}

			.beian-line {
				display: inline-flex;
				align-items: center;
				gap: 3px;
			}

			.beian-icon {
				width: 1.1em;
				height: 1.1em;
				flex: 0 0 1em;
				object-fit: contain;
			}

			.beian-link {
				color: inherit;
				text-decoration: none;
			}

			.beian-link:hover {
				text-decoration: underline;
			}

			.beian-icp {
				color: inherit;
				margin-left: 30px;
				text-decoration: none;
			}

			.beian-icp:hover {
				text-decoration: underline;
			}
		}
	}
</style>